// extracted by mini-css-extract-plugin
export default {"RoundIconButton":"RoundIconButton_RoundIconButton__x2p9c","Small":"RoundIconButton_Small__NxTWX","Icon":"RoundIconButton_Icon__JX+MQ","Label":"RoundIconButton_Label__tid06"};